const MAPBOX_TOKEN =
  'pk.eyJ1IjoidGlvdGRldiIsImEiOiJjbGlvdTZnZTkwMm96M21uNWcxcG9hNmlpIn0.VKCE0hOvRMFPSOipLIMe2w';

function itineraryMapboxUrl(
  itinerary,
  { countryCode, bbox },
  useBbox,
  width,
  keepMapboxCredits,
) {
  const { places } = itinerary;
  const dark = true;
  let pins = '';
  places.forEach(({ coordinates }, i) => {
    if (coordinates) {
      pins += `pin-l-${i + 1}+${dark ? '004D40' : '80CBC4'}(${coordinates[0]},${
        coordinates[1]
      })`;
      if (i < places.length - 1) pins += ',';
    }
  });
  const mapImage = `https://api.mapbox.com/styles/v1/${
    useBbox ? 'tiotdev/clje0u8cz003201quc5dz9wyg' : 'mapbox/streets-v12'
  }/static/${pins}/${useBbox ? JSON.stringify(bbox) : 'auto'}/${
    width || 400
  }x400@2x?access_token=${MAPBOX_TOKEN}&setfilter=[%22!=%22,%22iso_3166_1%22,%22${countryCode.toUpperCase()}%22]&layer_id=admin-0-boundary${
    keepMapboxCredits ? '' : '&logo=false&attribution=false'
  }`;
  return mapImage;
}

module.exports = itineraryMapboxUrl;
